import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { NavigationEvents } from '@mc/track-event'
import Link from 'components/Link'
import { trackPlansClick } from '../events'

export const PlansLink = ({ className = '' }: { className?: string }) => {
  const { t } = useTranslation('@mc/next')

  const onPlansCtaClick = () => {
    trackPlansClick(NavigationEvents.LEVELS.PRIMARY)()
  }

  return (
    <Link
      isBasic
      href={paths.checkout}
      className={`d-none d-lg-block mc-ml-4 ${className}`}
      onClick={onPlansCtaClick}
      passHref
    >
      {t('nav.cta.plans')}
    </Link>
  )
}
